<template>
	<div class="safety">
		<div class="line">
			<div class="title">微信账号</div>
			<div class="username van-ellipsis">
				<span class="isbound" v-if="wechat">已绑定</span>
				<span class="nobound" v-else  @click="boundWechat()">未绑定</span>
				<span class="ml-5" v-if="wechat">{{wechat}}</span>
			</div>
		</div>
		<div class="line">
			<div class="title">手机号</div>
			<div class="username">
				<span class="isbound" v-if="mobile">已绑定</span>
				<span class="nobound" v-else @click="boundMobile()">未绑定</span>
				<span class="ml-5" v-if="mobile">{{mobile}}</span>
			</div>
		</div>
	</div>
</template>
<script>
	import common from '../../../api/common';
	import post from '../../../api/lexus/release';
	import member from '../../../api/member/memberinfo';
	import { mapState } from 'vuex';
	import { Grid, GridItem,Field,Button,Icon } from 'vant';
	export default {
		data () {
			return {
				wechat:'',
				mobile:'',
				img:{
					approve: require('../../../assets/img/lexus/member/approceing.png')
				}
			}
		},
		computed: {
			...mapState({
				user: state => state.param.user,
				source: state => state.param.source
			})
		},
		created () {
			this.weburl=process.env.VUE_APP_URL
			this.$store.commit('param/show', false)
			this.$appService.isShowReturn({state: true})
			this.$appService.isTabbar({state: true})
			this.source = this.$route.query.source
			if(this.$route.query.token){
				this.token = this.$route.query.token
				this.$store.dispatch('param/setToken', this.$route.query.token)
				this.user_id = this.$route.query.userid
				this.source = this.$route.query.source
			}
			this.$appService.getToken(v => {
				if(v.token) {
					this.$store.dispatch('param/setToken', v.token)
				} else {
					this.$appService.needLogin()
				}
			})
			this.getMemberInfo()
			var params={
				event_code: '账号安全',
				event_id: '',
				title: '',
				value: '',
				path: '/Lexus/My/MySafety.vue',
				user_id: this.user ? this.user.id : 0,
				source: this.source
			}
			common.BurialPoint(params).then(res => {
				if(res.data.state==1){
				}
			})
			var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
		},
		methods: {
			getMemberInfo(){
				member.getMemberInfo({source:this.source}).then(res => {
					if(res.data.state == 1) {
						this.wechat=res.data.data.username
						this.mobile=res.data.data.mobile

					}
				})
			},
			boundWechat(){

			},
			boundMobile(){
				this.$router.push({name:'LexusBoundMobile',params:{source:this.source}});
			},
			// boundMobile(){
			// 	var params={
			// 		url:this.weburl+'/lexus/my/boundmobile?source='+this.source,
			// 		isReturn: true 
			// 	}
			// 	this.$appService.openWebView(params)
			// }
		},
		components: {
			[Grid.name]: Grid,
			[GridItem.name]: GridItem,
			[Field.name]:Field,
			[Button.name]:Button,
			[Icon.name]:Icon
		}
	}
</script>
<style lang="scss">
.safety{
	margin-top: 15px;
	.line{
		font-size:14px;
		padding:0 15px;
		display: flex;
		border-bottom: 1px solid #EEEEEE;
		.title{
			flex: 1;
			padding:20px 0;
		}
		.username{
			max-width: 80%;
			color: #999999;
			padding:20px 0;
			.isbound{
				background-color: #D8D8D8;
				font-size:12px;
				padding:4px 12px;
				border-radius: 2px;
			}
			.nobound{
				color: #fff;
				background-color: #605C6B;
				font-size:12px;
				padding:4px 12px;
				border-radius: 2px;
			}
			.ml-5{
				margin-left: 5px;
			}
		}
	}
}
</style>
